/**
 * API Configuration
 * Central configuration for API endpoints, timeouts, and settings
 */

import { env } from './env';
import { TIME, PAGINATION as PAGINATION_CONSTANTS } from '../constants/app.constants';

export const API_CONFIG = {
  // Base URL from environment variable
  BASE_URL: env.API_ENDPOINT,
  
  // Request timeout (30 seconds)
  TIMEOUT: TIME.THIRTY_SECONDS,
  
  // Token storage keys
  TOKEN_KEYS: {
    ACCESS_TOKEN: 'kaps_access_token',
    REFRESH_TOKEN: 'kaps_refresh_token',
    TOKEN_EXPIRY: 'kaps_token_expiry',
    USER_DATA: 'kaps_user_data',
  },
  
  // JWT expiry buffer (refresh 5 minutes before expiry)
  TOKEN_REFRESH_BUFFER: TIME.FIVE_MINUTES,
  
  // Pagination defaults
  PAGINATION: PAGINATION_CONSTANTS,
  
  // Request retry configuration
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000,
  },
} as const;

/**
 * API Response Codes from backend
 */
export enum ApiResponseCode {
  SUCCESS = 'SUCCESS',
  BAD_REQUEST = 'BAD_REQUEST',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
}

/**
 * HTTP Status Codes
 */
export enum HttpStatus {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  INTERNAL_SERVER_ERROR = 500,
}
